import React from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { SimpleForm } from "@/shared/components/text-box/simple-form";


interface Props {
  ocrImageFilename?: string;
  onTapCloseModal: () => void;
  onTapCompleteModal: (ocrAccountId?: string) => void;
}

export const OcrImageDeleteModal = (props: Props) => {
  const {
    ocrImageFilename,
    onTapCloseModal,
    onTapCompleteModal,
  } = props;

return (
    <BasePageModal
      title="OCR画像の削除"
      className="md-ocr-image-delete"
      isSub={true}
      handleClose={() => {
        onTapCloseModal();
      }}
      bottomChildren={
        <>
        <BaseRoundButton
          buttonText="キャンセル"
          className="btn-cancel"
          onClick={() => {
            onTapCloseModal();
          }}
        />
        <BaseRoundButton
          buttonText="削除"
          className="open-modal"
          onClick={() => {
            onTapCompleteModal();
          }}
          id="action"
        />
        </>
      }
    >
      <h2>この画像を削除します。よろしいですか？</h2>
      <dl>
        <SimpleForm
          id="ocrImageFilename"
          value={ocrImageFilename || ""}
          isReadOnly={true}
          title="ファイル名"
          onChange={() => {}}
          labelEnable={true}
          descriptionType={true}
        />
      </dl>
    </BasePageModal>
  );
}